import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import * as $ from 'jquery';
import * as AOS from 'aos';

@Component({
  selector: 'app-que-son-computos',
  templateUrl: './que-son-computos.component.html',
  styleUrls: ['./que-son-computos.component.css']
})
export class QueSonComputosComponent implements OnInit {

  constructor(private titleService: Title) {
    $(document).ready(function () {
      $('body').on('click', 'span', function () {
        // alert($(this).attr('id'))
        // console.info(this.hipervinculo);
      })
    })
  }
  ngOnInit() {

    AOS.init({
      duration: 500,
      easing: 'linear',
    });

    // $(document).ready(function () {
    //   $(".subrayado").removeClass("subrayado");
    //   $("#Quesonloscomputos").addClass("subrayado");
    //   $('.active-INE').removeClass('active-INE');
    //   $(".subrayado").closest('.nav-item').find("a").addClass('active-INE');
    //   $("#main").removeClass("m-main-menu");
    // });
    this.titleService.setTitle('¿Qué son los Cómputos? | CentroAyuda Cómputos');
  }


}



// WEBPACK FOOTER //
// ./src/app/components/conoce-computos/que-son-computos/que-son-computos.component.ts